export enum OrderByOptions {
  Ascendent = 'Oldest - Newest',
  Descendent = 'Newest - Oldest',
}
